import { Linkedin, Facebook, Instagram } from "lucide-react";

const SOCIALS = [
  { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/company/electrohaul/" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61591561517766" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/electrohaulmobility/" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="overflow-hidden border-t border-line">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="flex flex-col items-start justify-between gap-4 py-8 font-mono text-[10px] uppercase tracking-[0.2em] text-smoke sm:flex-row sm:items-center">
          <p>© 2026 Electrohaul Private Limited</p>
          <div className="flex items-center gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`ElectroHaul on ${s.label}`}
                data-testid={`social-${s.label.toLowerCase()}`}
                className="flex h-9 w-9 items-center justify-center border border-line text-smoke transition-colors duration-300 hover:border-volt hover:text-volt"
              >
                <s.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
          <p>Zero-Emission Freight · Made in India</p>
        </div>
      </div>
    </footer>
  );
}
